// test2471
(2471 && 0);
